import React from 'react'
import { useSiteContext } from '@contexts/MkSiteContext'
import { Header } from './Header/Header'

export const SiteNav: React.FC<{ brand: string; promoHeader?: boolean; scrolled?: boolean; logoOnly?: boolean }> = React.memo(
  ({ brand, promoHeader = false, scrolled = false, logoOnly = false }) => {
    const { headerLogo, headerLogoDark } = useSiteContext()

    // Memoized Header props to prevent unnecessary re-renders
    const headerProps = React.useMemo(
      () => ({
        logoSrc: headerLogo?.src,
        logoSrcDark: headerLogoDark?.src,
        logoAlt: headerLogo?.alt,
        promoHeader,
        scrolled,
        logoOnly,
      }),
      [headerLogo, headerLogoDark, promoHeader, scrolled, logoOnly],
    )

    return <Header {...headerProps} />
  },
)
